<template>
<div class="service-card card mb-2" v-on:click="$emit('click')">
	<div class="card-body">

		<h5 v-if="showStatus" :class="statusClass">{{service.status}}</h5>

		<div class="d-flex justify-content-between align-items-center">
			<h3 class="card-title">
				<div>Service #{{service.job_num}}</div>
				<div v-if="service.job_name"><small>Name: <strong v-html="stripInlineEventHandlers(service.job_name)"></strong></small></div>
				<div v-if="service.customerCompanyName || service.customer_name_cache"><small>Customer: <strong>{{service.customerCompanyName || service.customer_name_cache}}</strong></small></div>
			</h3>
			<div v-if="service.emergencyIcon" class="text-danger text-center">
				<span v-html="stripInlineEventHandlers(service.emergencyIcon)"></span>
				Emergency
			</div>
		</div>

		<div class="row">
			<div class="col-sm-6">
				<div class="address" v-if="service.siteAddress" v-html="stripInlineEventHandlers(service.siteAddress)"></div>
				<div class="address" v-else>
					<div v-if="'ContactLocation' in service && service.ContactLocation">
						{{service.ContactLocation.location_name}}
					</div>

					<div v-if="service.suite">{{service.suite}}</div>
					{{service.address}}, {{service.city}}
				</div>

				<div class="mt-2">
					<h5 class='label'>Scheduled: </h5>
					<strong v-html="stripInlineEventHandlers(service.scheduledFor)"></strong> @ 
					<strong v-html="stripInlineEventHandlers(service.aptTime)"></strong>
				</div>
			</div>
			<div class="col-sm-6">

				<div class="mt-2" v-if="service.estimated_time > 0">
					<h5 class='label'>Estimated Time: </h5>
					<strong>{{ service.estimated_time }}</strong> hrs
				</div>

				<div class="mt-2">
					<h5 class="label">Crew Members: </h5>
					<strong>{{service.techList}}</strong>
				</div>
			</div>
		</div>

		<div v-if="extraFields.length" class="row mt-2">
			<div class="col-12">
				<div class="service-card-fields">
					<div v-for="field in extraFields" :key="field.key" class="service-card-field">
						<strong class="service-card-field-label">{{field.label}}</strong>
						<span class="service-card-field-value">
							<i v-if="field.type == 'boolean' && (service[field.key] == 1 || service[field.key] === true)" class="fa fa-check"></i>
							<i v-else-if="field.type == 'boolean' && (service[field.key] == 0 || service[field.key] === false)" class="fa fa-times"></i>
							<span v-else v-html="stripInlineEventHandlers(service[field.key])"></span>
						</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
</template>
<script type="text/javascript">
import ServiceMixins from "@/mixins/ServiceMixins"

export default {
	name: "ServiceCard",
	mixins: [ServiceMixins],
	props: ["service","showStatus"],
	data() {
		return {
			mapExpanded: false
		}
	},
	computed: {
		statusClass() {
			if (this.service.status == 'Dispatched' || this.service.status == '')
				return "text-warning"
			else if (this.service.status == 'Canceled')
				return "text-danger"
			else
				return "text-success"
		},
		extraFields() {
			let fields = []
			try {
				fields = this.mutatedFields()
			}
			catch (e) {
				fields = []
			}

			let handledKeys = [
				'emergencyIcon',
				'job_num',
				'job_name',
				'customerCompanyName',
				'siteAddress',
				'estimated_time',
				'scheduledFor',
				'aptTime'
			]

			return fields.filter(field => handledKeys.indexOf(field.key) == -1)
		}
	}
}
</script>

<style type="text/css" scoped>
	.service-card:hover {
		background-color: #EAE9E7;
		cursor: pointer;
	}

	.card-body h3 {
		text-transform: uppercase;
	}

	.label {
		display: inline;
		text-transform: uppercase;

	}

	.service-card-fields {
		display: flex;
		flex-wrap: wrap;
	}

	.service-card-field {
		width: 50%;
		padding-right: 10px;
		margin-top: 5px;
	}

	.service-card-field-label {
		display: inline-block;
		margin-right: 8px;
		text-transform: uppercase;
	}

	@media (max-width: 600px) {
		.service-card-field {
			width: 100%;
		}
	}
</style>